module.exports =
# PRODUCTION use: ...//auth.gensite.be/... in B2bCompanyGeneraliUri value
# STAGING use: ...//betaoam.gensite.be/... in B2bCompanyGeneraliUri value
# B2bCompanyGeneraliUri : "https://auth.gensite.be/login/WillemotSessionInit.jsp?o=1"
#  B2bCompanyGeneraliUri : "https://betaoam.gensite.be/login/WillemotSessionInit.jsp?o=1"
#  B2bCompanyVerzekeringenUri : "/b2bconnection/vivium?"
  B2bCompanyGeneraliUri : "https://auth.be.athora.site/login/WillemotSessionInit.jsp?o=1"
#  B2bCompanyGeneraliUri : "https://auth-beta.be.athora.site/login/WillemotSessionInit.jsp?o=1"
  B2bCompanyVerzekeringenUri : "/b2bconnection/vivium?"
  WillemotEmails: ['@willemot1841.be', '@ovb.willemot.eu', '@willemot.be', '@izegemverzekeringen.be', '@knokkeverzekeringen.be', '@sintniklaasverzekeringen.be', '@easinsure.be', '@verzekeringsplanner.be']
  AgentAppVersion: "10.0"



// WEBPACK FOOTER //
// ./components/environments.coffee